import { Routes } from '@angular/router';
import { environment } from '@env/environment';
import { authGuard } from './core/guards/auth.guard';
import { publicAuthGuard } from './core/guards/public-auth.guard';
import { siteRoutes } from './features/site/site.routes';
import { NotFoundComponent } from './features/status/not-found.component';
import { OFFLINE_PATH, OfflineComponent } from './features/status/offline.component';

export const routes: Routes = [
	/* Site público: landing, preços e páginas de apoio, com menu e rodapé próprios. */
	{
		path: '',
		loadComponent: () => import('./features/site/layout/site-layout.component').then((m) => m.SiteLayoutComponent),
		children: siteRoutes,
	},
	{
		path: 'auth',
		loadComponent: () => import('./layout/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
		children: [
			{ path: '', redirectTo: 'login', pathMatch: 'full' },
			{
				path: 'login',
				title: 'Entrar',
				canActivate: [publicAuthGuard],
				loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent),
			},
			{
				path: 'register',
				title: 'Criar conta',
				canActivate: [publicAuthGuard],
				loadComponent: () => import('./features/auth/register/register.component').then((m) => m.RegisterComponent),
			},
			{
				path: 'verify-code',
				title: 'Confira seu e-mail',
				canActivate: [publicAuthGuard],
				loadComponent: () =>
					import('./features/auth/verify-code/verify-code.component').then((m) => m.VerifyCodeComponent),
			},
			{
				path: 'callback',
				loadComponent: () => import('./features/auth/callback/callback.component').then((m) => m.CallbackComponent),
			},
		],
	},
	/* As perguntas do começo, logo depois de criar a conta. Fora da casca, sem distração. */
	{
		path: 'onboarding',
		title: 'Comece por aqui',
		canActivate: [authGuard],
		loadComponent: () => import('./features/first-steps/first-steps.component').then((m) => m.FirstStepsComponent),
	},
	{
		path: 'app',
		canActivate: [authGuard],
		loadComponent: () => import('./layout/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
		children: [
			{
				path: '',
				loadChildren: () => import('./features/private/private.routes').then((m) => m.privateRoutes),
			},
		],
	},
	{
		path: 'p/share/:token',
		data: { ownShareMeta: true },
		loadComponent: () =>
			import('./features/public-project-view/public-project-view.component').then((m) => m.PublicProjectViewComponent),
		title: 'Acompanhamento de Obra',
	},

	/* A mesma tela do portal, com uma obra de exemplo. É o que a landing mostra. */
	{
		path: 'demo',
		loadComponent: () =>
			import('./features/public-project-view/public-project-view.component').then((m) => m.PublicProjectViewComponent),
		title: 'ObraSync · exemplo de acompanhamento',
		data: {
			demo: true,
			ownShareMeta: true,
			description:
				'Uma obra de exemplo do ObraSync, como o cliente vê: andamento, etapas, fotos semana a semana e contato. Sem cadastro.',
		},
	},

	/* Galeria dos componentes de shared/ui. Só fora de produção. */
	...(environment.production
		? []
		: [
				{
					path: 'ui',
					title: 'Prancheta · componentes',
					loadComponent: () => import('./features/ui-gallery/ui-gallery.component').then((m) => m.UiGalleryComponent),
				},
				/* Modo de dados de exemplo: ver core/dev/dev-mock.ts. */
				...['sign-in', 'sign-out'].map((mode) => ({
					path: `dev/${mode}`,
					title: 'Modo de exemplo',
					data: { mode },
					loadComponent: () => import('./features/dev/dev-session.component').then((m) => m.DevSessionComponent),
				})),
			]),

	/* Sem internet e sem a tela guardada: ver offlineNavigationHandler. Fica no pacote principal. */
	{ path: OFFLINE_PATH, component: OfflineComponent, title: 'Sem conexão' },
	{ path: '**', component: NotFoundComponent, title: 'Página não encontrada' },
];
